export class DeleteTaskCommentResponseDto {
    result: boolean;

    constructor(result: boolean) {

        this.result = result;
    }
}
